import { EventBus } from '../../helpers';

export const payflowTopBarEventBus = new EventBus<{
  logoClicked: [];
  exitClicked: [];
}>();
